'use client'

import { useCallback, useEffect, useState } from 'react'
import Link from 'next/link'
import { Modal } from '@/components/Modal'
import { useDict } from '@/lib'
import { createAcceptAllCookieConsentChoices } from '@/lib/analytics/cookieConsentCatalog'
import {
  hasValidCookieConsent,
  saveCookieConsent,
} from '@/utils/cookieConsentStorage'
import s from './CookieConsent.module.scss'

export function CookieConsentModal() {
  const dict = useDict('cookie-consent')
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setIsOpen(!hasValidCookieConsent())
  }, [])

  const handleAcceptAll = useCallback(() => {
    saveCookieConsent(createAcceptAllCookieConsentChoices())
    setIsOpen(false)
  }, [])

  if (!dict) return null

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {}}
      closable={false}
      title={dict.title}
    >
      <div className={s.wrapper}>
        <p className={s.description}>
          {dict.description}{' '}
          <Link href="/polityka-prywatnosci" className={s.privacyLink}>
            {dict.privacyLink}
          </Link>
          .
        </p>

        <button
          type="button"
          className={s.acceptButton}
          onClick={handleAcceptAll}
        >
          {dict.acceptAll}
        </button>
      </div>
    </Modal>
  )
}
